export const SUB_ROUTE_PERIODICITY_EXPORT_ID = 'sub-route-periodicity';
export const SUB_ROUTE_PERIODICITY_TITLE = 'Frecuencia de Rutas - Asignados';

export const SUB_ROUTE_PERIODICITY_NO_EXPORT_ID = 'sub-route-periodicity-no';
export const SUB_ROUTE_PERIODICITY_NO_TITLE = 'Frecuencia de Rutas - No Asignados';

export const LOCALIZED_PROPERTIES = {
  externalKeys: 'CÓDIGO',
  name: 'NOMBRE',
  commercialName: 'NOMBRE COMERCIAL',
  NIT: 'RTN',
  DNI: 'DNI',
  subRoutes: 'RUTAS ASIGNADAS',
  principalContact: 'CONTACTO',
  principalPhone: 'TELÉFONO',
  emails: 'CORREO',
  principalAddress: 'DIRECCIÓN',
  principalAddressLocation: 'UBICACIÓN',
  frequenciesFromThisSubRoute: 'FRECUENCIAS',
  frecuencyFromEvent: 'EVENTOS'
};
